// ============================================================================
// STORAGE KEYS — Single Source of Truth
// ============================================================================
// All localStorage keys used throughout the application.
// Every localStorage access MUST use these constants. Zero magic strings.

export const STORAGE_KEYS = {
  // Tokens
  ACCESS_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',

  /** Legacy/mock auth mode token (REACT_APP_AUTH_MODE=legacy). Not a JWT —
   *  it exists only so `hasActiveSession()` can tell "logged in" from "logged
   *  out" in the sample login flow. Mirrors react-project-template. */
  LEGACY_AUTH_TOKEN: 'authToken',

  // Tenant context
  TENANT_ID: 'tenant_id',
  // Tenant branding (name + logo) captured from the authenticate response.
  // Persisted as one JSON blob (mirrors react-project-template's F3 pattern)
  // so a reload rehydrates without a second tenant-hub round-trip.
  TENANT_INFO: 'tenant_info',
  APP_ID: 'app_id',
  USER_ID: 'user_id',

  // User info
  USER_NAME: 'user_name',
  USER_EMAIL: 'user_email',
  USER_FIRST_NAME: 'user_first_name',
  USER_LAST_NAME: 'user_last_name',
  FULL_NAME: 'full_name',
  USER_ROLE: 'user_role',

  // Permissions
  PERMISSIONS: 'permission_context',
  SCOPE_CONFIG: 'scope_configuration',

  // Scope selections
  SELECTED_ENTITY_ID: 'selected_entity_id',
  SELECTED_ENTITY_NAME: 'selected_entity_name',
  SELECTED_BU_ID: 'selected_bu_id',
  SELECTED_BU_NAME: 'selected_bu_name',
  SELECTED_FY_ID: 'selected_fy_id',
  SELECTED_FY_NAME: 'selected_fy_name',
  SELECTED_FY_CODE: 'selected_fy_code',

  // App state
  NAVIGATION_MENU: 'NAVIGATION_MENU',
  MODULES_CONFIG: 'MODULES_CONFIG',
  USER: 'user',
  APP_CONFIG: 'APP_CONFIG',

  // Auth mode
  AUTH_MODE: 'auth_mode',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
